<script setup>
  import { useWelcomeToClub } from '@/features/clubRegister/utils/useWelcomeToClub.js'
  import FMRGBLogo from '@/features/ui/components/logos/FMRGBLogo.vue'
  import ModalDialog from '@/features/ui/components/modalDialog/ModalDialog.vue'

  const welcomeToClub = useWelcomeToClub()
</script>

<template>
  <ModalDialog
    :visible="welcomeToClub.isVisible.value"
    modal
    :style="{ width: '40rem' }"
    :dismissableMask="true"
    :closable="false"
  >
    <div class="content">
      <FMRGBLogo class="logo" />

      <h1>Welcome to your new Friendly Manager club administration tool</h1>

      <Button label="Continue" size="large" @click="welcomeToClub.closeWelcomeToClub" />
    </div>
  </ModalDialog>
</template>

<style lang="scss" scoped>
  .content {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 30px;
  }

  .logo {
    max-width: 250px;
  }

  h1 {
    font-size: 18px;
    font-weight: 500;
  }
</style>
